
import { api } from "@/api/api";
import { ApiGetCourseScheduleDtoType, ApiGetKursAdminCourseDto } from "@/api/generated/Api";
import BaseLayout from "@/components/shared/BaseLayout.vue";
import BaseTableFiltered from "@/components/shared/table/BaseTableFiltered.vue";
import { CourseStatus } from "@/shared/enums/CourseStatus.enum";
import { SingleCourseRouteNames } from "@/shared/enums/RouteNames/singleCourseRouteNames.enum";
import { formatDateTime, formatLocalizedTime } from "@/shared/helpers/dateHelpers";
import { globalLoadingWrapper } from "@/shared/helpers/loadingHelpers";
import { useNavigateBack } from "@/shared/helpers/navigationHelpers";
import { useRoute, useRouter, useStore } from "@/shared/useHelpers";
import { StoreState } from "@/store/store.state.interface";
import { computed, defineComponent, onMounted, ref } from "@vue/composition-api";
import isBefore from "date-fns/isBefore";

export default defineComponent({
  name: "CourseAttendancePage",
  components: {
    BaseLayout,
    BaseTableFiltered,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore<StoreState>();
    const course = computed(() => store.state.courses.course);
    const search = ref("");
    const schedule = computed(() =>
      courseValues.value?.plan?.schedules?.filter(
        (scheduleEntry) => scheduleEntry.start && isBefore(new Date(scheduleEntry?.start), new Date())
      )
    );
    const courseHasParticipants = ref(false);
    const courseValues = ref<ApiGetKursAdminCourseDto>();

    const openCourseAttendanceParticipant = (startDate: string) => {
      router.push({
        name: SingleCourseRouteNames.CourseAttendanceParticipant,
        params: {
          id: route.params.id,
          startDate,
        },
      });
    };

    const navigateToParticipantList = () => {
      router.push({
        name: SingleCourseRouteNames.CourseParticipants,
        params: {
          id: route.params.id,
        },
      });
    };

    const checkIfCourseParticipants = async () => {
      await globalLoadingWrapper({ blocking: true }, async () => {
        courseHasParticipants.value =
          (await api.course.getCourseParticipantsByCourseIdAsync(+route.params.id)).data.length > 1;
      });
    };

    const getCourse = async () => {
      await globalLoadingWrapper({ blocking: true }, async () => {
        courseValues.value = (await api.course.getCourseByIdFilteredByDepartmentAsync(+route.params.id)).data;
      });
    };

    onMounted(async () => {
      await Promise.all([getCourse(), checkIfCourseParticipants()]);
    });
    const getDifferenceInHours = (courseEvent: ApiGetCourseScheduleDtoType) => {
      const diffHours = Math.abs(new Date(courseEvent.end).getTime() - new Date(courseEvent.start).getTime()) / 36e5;

      return diffHours.toFixed(1);
    };

    return {
      course,
      headers,
      search,
      schedule,
      courseValues,
      isCourseDone: computed(() => courseValues.value?.status === CourseStatus.Closed),
      openCourseAttendanceParticipant,
      getDifferenceInHours,
      formatDateTime,
      navigateToParticipantList,
      courseHasParticipants,
      formatLocalizedTime,
      navigateToCourseDashboard: () => useNavigateBack(SingleCourseRouteNames.CourseDashboard),
    };
  },
});

const headers = [
  {
    text: "Startdato og tidspunkt",
    value: "start",
  },
  {
    text: "Slutt tidspunkt",
    value: "end",
  },
  {
    text: "Handlinger",
    value: "actions",
  },
  {
    text: "Tittel",
    value: "title",
  },
  {
    text: "Alt fremmøte registrert",
    value: "isAllAttendancesRegistered",
  },
  {
    text: "Antall timer",
    value: "hourAmount",
  },
];
